<template>
    <div class="collect-content" v-show="showCollect && !foldRobot" :class="{'full':full, 'isMobile':isMobile}"  >
        <div class="top" v-show="foldRobot">
            <div class="title">我的收藏本</div>
            <i class="el-icon-close" @click="handleClose"></i>
        </div>

        <ul class="type-list">
            <!-- 题目收藏（带高中/初中二级菜单） -->
            <li>
                <el-tag @click.stop="toggleQuestionMenu" size="medium" :class="questionMenuShow ? 'active' : ''">题目收藏</el-tag>
                <ul v-show="questionMenuShow && showCollect" class="item-list sub-menu">
                    <li @click.stop="navigateToQuestionCollect('high')">
                        <div class="item-content">
                            <i class="el-icon-reading" style="color:rgb(41, 186, 253);"></i>
                            <span class="item-title">高中题目</span>
                        </div>
                    </li>
                    <li @click.stop="navigateToQuestionCollect('middle')">
                        <div class="item-content">
                            <i class="el-icon-reading" style="color: #f7ba2a;"></i>
                            <span class="item-title">初中题目</span>
                        </div>
                    </li>
                </ul>
            </li>

            <!-- 图谱收藏 -->
            <li>
                <el-tag @click.stop="choosedRobot('graphCollect')" size="medium"
                    :class="graphShow ? 'active' : ''">图谱收藏</el-tag>
                <ul v-show="graphShow && showCollect" class="item-list" >
                    <template v-if="graphs && graphs.length">
                        <li v-for="(graph, count) in graphs" :key="'graph'+count">
                            <el-popover placement="right" width="260" trigger="hover" popper-class="collect-popover">
                                <div class="popover-content">
                                    <div class="popover-info">
                                        <i class="el-icon-picture-outline"></i>
                                        <span class="popover-title">{{ graph.kgid }}</span>
                                    </div>
                                    <div class="popover-action" @click.stop="cancelGraphCollect(graph, count)">
                                        <i v-if="!graph.deleting" class="el-icon-star-on" style="color: #f7ba2a;"></i>
                                        <i v-else class="el-icon-loading"></i>
                                        <span>取消收藏</span>
                                    </div>
                                </div>
                                <div class="item-content" slot="reference" @click.stop="showGraph(graph)">
                                    <i class="el-icon-picture-outline"></i>
                                    <span class="item-title">{{ graph.kgid }}</span>
                                    <span class="item-count">{{ count + 1 }}</span>
                                </div>
                            </el-popover>
                        </li>
                    </template>
                    <li v-else class="empty-item">暂无图谱收藏</li>
                </ul>
            </li>

            <!-- 试卷收藏 -->
            <li>
                <el-tag @click.stop="choosedRobot('paperCollect')" size="medium"
                    :class="paperShow ? 'active' : ''">试卷收藏</el-tag>
                <ul v-show="paperShow && showCollect" class="item-list">
                    <template v-if="papers && papers.length">
                        <li v-for="(paper, count) in papers" :key="'paper'+count">
                            <el-popover placement="right" width="260" trigger="hover" popper-class="collect-popover">
                                <div class="popover-content">
                                    <div class="popover-info">
                                        <i class="el-icon-document"></i>
                                        <span class="popover-title">{{ getPaperTitle(paper) }}</span>
                                    </div>
                                    <div class="popover-action" @click.stop="cancelPaperCollect(paper, count)">
                                        <i v-if="!getDeleting(paper)" class="el-icon-star-on" style="color: #f7ba2a;"></i>
                                        <i v-else class="el-icon-loading"></i>
                                        <span>取消收藏</span>
                                    </div>
                                </div>
                                <div class="item-content" slot="reference" @click.stop="showPaper(paper)">
                                    <i class="el-icon-document"></i>
                                    <span class="item-title">{{ getPaperTitle(paper) }}</span>
                                    <span class="item-count">{{ count + 1 }}</span>
                                </div>
                            </el-popover>
                        </li>
                    </template>
                    <li v-else class="empty-item">暂无试卷收藏</li>
                </ul>
            </li>

            <!-- 专题收藏 -->
            <li>
                <el-tag @click.stop="choosedRobot('topicCollect')" size="medium"
                    :class="topicShow ? 'active' : ''">专题收藏</el-tag>
                <ul v-show="topicShow && showCollect" class="item-list">
                    <template v-if="topics && topics.length">
                        <li v-for="(t, count) in topics" :key="'topic'+count">
                            <el-popover placement="right" width="260" trigger="hover" popper-class="collect-popover">
                                <div class="popover-content">
                                    <div class="popover-info">
                                        <i class="el-icon-collection-tag"></i>
                                        <span class="popover-title">{{ t.title }}</span>
                                    </div>
                                    <div class="popover-action" @click.stop="cancelTopicCollect(t, count)">
                                        <i v-if="!t.deleting" class="el-icon-star-on" style="color: #f7ba2a;"></i>
                                        <i v-else class="el-icon-loading"></i>
                                        <span>取消收藏</span>
                                    </div>
                                </div>
                                <div class="item-content" slot="reference" @click.stop="showTopic(t)">
                                    <i class="el-icon-collection-tag"></i>
                                    <span class="item-title">{{ t.title }}</span>
                                    <span class="item-count">{{ count + 1 }}</span>
                                </div>
                            </el-popover>
                        </li>
                    </template>
                    <li v-else class="empty-item">暂无专题收藏</li>
                </ul>
            </li>
        </ul>
    </div>
</template>

<script>
import robotMixin from "@/mixin/robot.js";
import { mapState } from "vuex/dist/vuex.common.js";
import { removeGraph } from "@/api/chat/knowledgeGraph";
import { removePaperCollect, removeTopic, showPaper } from "@/api/chat/sendReceive";
import { getLevel } from '@/utils/chat/chatUtil';
import pubsub from "pubsub-js";
import store from "@/store/index";

export default {
    data() {
        return {
            isShow: true,
            full: false,
            questionMenuShow: false,   // 控制高中/初中二级菜单的显示
        }
    },
    mixins: [robotMixin],
    props: ["showCollect"],
    computed: {
        ...mapState(["foldRobot"]),
        // 判断是否移动端（可根据实际全局状态或UA判断）
        isMobile() {
            return document.body.clientWidth <= 768;
        }
    },
    mounted() {
        this.full = this.$attrs.full;
    },
    methods: {
        handleClose() {
            this.$emit("hideCollect");
        },

        // 切换题目收藏的二级菜单（高中/初中选项）
        toggleQuestionMenu() {
            // 点击题目收藏标签时，切换二级菜单显示，并可选择折叠其他收藏（可选）
            if (!this.questionMenuShow) {
                // 可在此处自动折叠其他收藏模块（与原始交互一致，提升体验）
                this.graphShow = false;
                this.paperShow = false;
                this.topicShow = false;
            }
            this.questionMenuShow = !this.questionMenuShow;
        },

        // 跳转到对应智能体并加载题目收藏列表
        navigateToQuestionCollect(levelType) {
            // 高中 -> exercises，初中 -> mexercises（根据实际路由配置调整）
            const robotId = levelType === 'high' ? 'exercises' : 'mexercises';
            // 获取或创建会话ID（robotSessionMap 由 robotMixin 提供）
            let sessionId = this.robotSessionMap?.[robotId];
            if (!sessionId) sessionId = +new Date() + "";
            // 路由跳转到聊天窗口
            this.$router.push(`/chatSearch/${robotId}/${sessionId.slice(-10)}`);

            // 移动端环境折叠收藏面板（可选）
            if (this.isMobile) {
                store.commit("SET_FOLDROBOT", true);
                this.$emit("hideCollect");
            }

            // 发布事件，通知目标智能体加载题目收藏列表
            pubsub.publish("getQuestionList", { type: "questionCollect", level: levelType });
            // 关闭二级菜单
            this.questionMenuShow = false;
        },

        // ----- 以下为原有方法（保持不变）-----
        getPaperTitle(paper) {
            if (!paper) return '未知试卷';
            if (typeof paper === 'string') return paper.replace(/##/g, '');
            return paper.title ? paper.title.replace(/##/g, '') : '未知试卷';
        },

        getDeleting(paper) {
            if (typeof paper === 'object' && paper.deleting) return true;
            return false;
        },

        async cancelGraphCollect(graph, index) {
            if (graph.deleting) return;
            this.$set(graph, 'deleting', true);
            try {
                const res = await removeGraph({ kgid: graph.kgid });
                if (res && (res.status === 200 || res.status === 204)) {
                    this.$message.success("已取消收藏");
                    await this.getGraphCollectionNames();
                } else {
                    this.$message.error(res?.data?.message || "取消失败");
                }
            } catch (error) {
                console.error(error);
                this.$message.error("网络错误，取消失败");
            } finally {
                this.$set(graph, 'deleting', false);
            }
        },

        async cancelPaperCollect(paper, index) {
            let paperObj = paper;
            if (typeof paper === 'string') {
                paperObj = {
                    title: paper,
                    blockid: null,
                    questionid: [],
                    level: getLevel(),
                    deleting: false
                };
                this.$set(this.papers, index, paperObj);
            }

            if (!paperObj.level) paperObj.level = getLevel();
            if (!paperObj.questionid) paperObj.questionid = [];
            if (paperObj.deleting) return;

            this.$set(paperObj, 'deleting', true);
            try {
                const { blockid, questionid, title, level } = paperObj;
                const cleanTitle = title.replace(/##/g, '');

                const res = await removePaperCollect({
                    blockid,
                    questionid,
                    title,
                    level
                });

                if (res.status === 200 || res.status === 204) {
                    this.$message.success("已取消收藏");
                    await this.getPaperCollectionNames();
                } else {
                    const errMsg = res?.data?.message || "取消失败";
                    if (errMsg.includes("不存在") || res.status === 404) {
                        this.papers.splice(index, 1);
                        this.$message.warning("该试卷已不存在，已从收藏列表中移除");
                        await this.getPaperCollectionNames();
                    } else {
                        this.$message.error(errMsg);
                    }
                }
            } catch (error) {
                console.error(error);
                this.$message.error("网络错误，取消失败");
            } finally {
                this.$set(paperObj, 'deleting', false);
            }
        },

        async cancelTopicCollect(topic, index) {
            if (topic.deleting) return;
            this.$set(topic, 'deleting', true);
            try {
                const level = topic.level || getLevel();
                const res = await removeTopic({ title: topic.title, level });
                if (res && (res.status === 200 || res.status === 204)) {
                    this.$message.success("已取消收藏");
                    await this.getTopicCollectionNames();
                } else {
                    this.$message.error(res?.data?.message || "取消失败");
                }
            } catch (error) {
                console.error(error);
                this.$message.error("网络错误，取消失败");
            } finally {
                this.$set(topic, 'deleting', false);
            }
        }
    },
}
</script>

<style lang="scss" scoped>
ul {
    list-style: none;
}

.collect-content {
    margin-top: 6px;
    width: 200px;
    list-style: none;
    font-size: 0.9em;
    cursor: default;

    .top {
        display: none;
    }

    .type-list {
        margin-left: -2.8em;
        margin-top: 10px;
        margin-bottom: 0;

        > li {
            margin-bottom: 10px;

            .el-tag {
                margin-left: 45px;
                cursor: pointer;
                padding: 0 8px;
                transition: all 0.2s;

                &:hover {
                    box-shadow: $base_green 0 0 8px;
                }

                &.active {
                    box-shadow: $base_green 0 0 8px;
                }
            }

            &:last-child {
                margin-bottom: 5px;
            }
        }
    }

    .item-list {
        margin-top: 8px;
        margin-left: 0;
        padding-left: 45px;
        width: 100%;
        max-height: 50vh;
        min-height: 50px;
        overflow-y: auto;
        font-size: 0.9em;
        box-sizing: border-box;

        &::-webkit-scrollbar {
            width: 4px;
        }
        &::-webkit-scrollbar-track {
            background: #f1f1f1;
            border-radius: 4px;
        }
        &::-webkit-scrollbar-thumb {
            background: #c1c1c1;
            border-radius: 4px;
            &:hover {
                background: #a8a8a8;
            }
        }

        li {
            margin-bottom: 6px;
            cursor: pointer;
            color: var(--txt-default-color);
            background: rgba(0, 0, 0, 0.02);
            border-radius: 8px;
            transition: all 0.2s ease;

            &:hover {
                background: rgba(0, 0, 0, 0.05);
                transform: translateX(2px);
                .item-content .item-title {
                    color: $base_green;
                }
            }

            .item-content {
                display: flex;
                align-items: center;
                gap: 8px;
                padding: 6px 12px;
                width: 100%;
                box-sizing: border-box;

                i {
                    font-size: 16px;
                    color: #6c757d;
                    flex-shrink: 0;
                }

                .item-title {
                    flex: 1;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    font-size: 0.85em;
                }

                .item-count {
                    font-size: 0.7em;
                    color: #999;
                    background: #f0f0f0;
                    border-radius: 12px;
                    padding: 0 6px;
                    line-height: 1.4;
                    flex-shrink: 0;
                }
            }

            &.empty-item {
                text-align: center;
                color: #aaa;
                font-size: 0.85em;
                padding: 12px;
                cursor: default;
                background: transparent;
                &:hover {
                    background: transparent;
                    transform: none;
                }
            }
        }
    }

    // 题目收藏二级菜单样式（与普通 item-list 一致，无语序）
    .sub-menu {
        li {
            .item-content {
                .item-count {
                    display: none;
                }
            }
        }
    }
}

::v-deep .el-popover__reference {
    display: block;
    width: 100%;
}

// 全局 popover 样式
::v-deep .collect-popover {
    padding: 0;
    .popover-content {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 12px 16px;
        gap: 12px;
        .popover-info {
            display: flex;
            align-items: center;
            gap: 8px;
            flex: 1;
            overflow: hidden;
            i {
                font-size: 18px;
                color: #6c757d;
            }
            .popover-title {
                font-size: 14px;
                font-weight: 500;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }
        .popover-action {
            display: flex;
            align-items: center;
            gap: 6px;
            cursor: pointer;
            color: #f7ba2a;
            font-size: 14px;
            padding: 4px 8px;
            border-radius: 6px;
            transition: background 0.2s;
            &:hover {
                background: rgba(0, 0, 0, 0.05);
            }
            i {
                font-size: 18px;
            }
            span {
                font-size: 13px;
            }
        }
    }
}

// 移动端样式（保持与原第一个文件一致）
.isMobile {
    ul {
        margin: 0;
        padding: 0;
        margin-top: 18px;
    }

    .collect-content {
        width: 80vw;
        margin-left: calc(0.4rem + 12px);
        margin-top: -15px;

        &.full {
            top: -1em;
            left: 0 !important;
            padding-top: 0.5rem;
            margin-left: 0;
            margin-top: 15px;

            .item-list {
                max-height: 55vh;
                overflow-y: auto;
                padding-left: 1rem;
            }

            .type-list {
                margin-left: 1rem;
            }
        }

        .top {
            padding: 0 2em;
            display: flex;
            height: 2em;
            justify-content: space-between;
            align-items: center;
            font-size: 18px;
            font-weight: 600;

            .title {
                margin: 0 auto;
            }
        }

        .type-list {
            margin-left: 0;
        }

        .item-list {
            margin-left: 0 !important;
            padding-left: 0.8rem;
            width: 100%;
            max-height: calc(26vh - constant(safe-area-inset-bottom) - constant(safe-area-inset-top));
            max-height: calc(26vh - env(safe-area-inset-bottom) - env(safe-area-inset-top));

            li {
                text-align: left;
                font-size: $font_size;
                margin-bottom: 0.1rem;
                line-height: 1.2;

                .item-content {
                    padding: 8px 12px;
                    gap: 10px;

                    i {
                        font-size: 18px;
                    }

                    .item-title {
                        font-size: 0.9em;
                    }

                    .item-count {
                        font-size: 0.75em;
                        padding: 0 8px;
                    }
                }
            }
        }

        li {
            width: 100%;
            text-align: left;

            .el-tag {
                font-size: clamp(12px, 0.2rem, 20px);
                border-radius: 0.5;
                margin-left: 0;
            }
        }
    }

    ::v-deep .el-popover__reference,
    ::v-deep .el-popover__reference-wrapper {
        display: inline-block;
        width: 100% !important;
    }
}
</style>